export default "__VITE_ASSET__hG9P1UDZ__"